import ZH from './zh_cn.json'
import EN from './en.json'
import ZHTW from './zh_tw.json'
import AR from './AR.json'
import DE from './DE.json'
import ES from './ES.json'
import FR from './FR.json'
import ID from './ID.json'
import IT from './IT.json'
import JA from './JA.json'
import KO from './KO.json'
import NL from './NL.json'
import PL from './PL.json'
import PT from './PT.json'
import RU from './RU.json'
import SV from './SV.json'
import TH from './TH.json'
import TR from './TR.json'
import VI from './VI.json'
import MY from './MY.json'
import MS from './MS.json'

export default {
  config: {
    'zh-cn': ZH,
    'zh-tw': ZHTW,
    en: EN,
    ar: AR,
    de: DE,
    es: ES,
    fr: FR,
    id: ID,
    it: IT,
    ja: JA,
    ko: KO,
    nl: NL,
    pl: PL,
    pt: PT,
    ru: RU,
    sv: SV,
    th: TH,
    tr: TR,
    vi: VI,
    my: MY,
    ms: MS
  },
  code: [
    {
      code: 'en',
      name: 'English'
    },
    {
      code: 'zh-cn',
      name: '简体中文'
    },
    {
      code: 'zh-tw',
      name: '繁體中文'
    },
    {
      code: 'ja',
      name: '日本語'
    },
    {
      code: 'ko',
      name: '한국어'
    },
    {
      code: 'ru',
      name: 'Русский'
    },
    {
      code: 'de',
      name: 'Deutsch'
    },
    {
      code: 'fr',
      name: 'Français'
    },
    {
      code: 'it',
      name: 'Italiano'
    },
    {
      code: 'pl',
      name: 'Polski'
    },
    {
      code: 'tr',
      name: 'Türkçe'
    },
    {
      code: 'es',
      name: 'Español'
    },
    {
      code: 'pt',
      name: 'Português'
    },
    {
      code: 'sv',
      name: 'Svenska'
    },
    {
      code: 'th',
      name: 'ภาษาอังกฤษ'
    },
    {
      code: 'ar',
      name: 'العربية'
    },
    {
      code: 'id',
      name: 'Bahasa Indonesia'
    },
    {
      code: 'nl',
      name: 'Nederlands'
    },
    {
      code: 'vi',
      name: 'Tiếng Việt'
    },
    {
      code: 'ms',
      name: 'Melayu'
    }
  ]
}
